/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProfile = /* GraphQL */ `
  query GetProfile($id: ID!) {
    getProfile(id: $id) {
      id
      userName
      familyName
      givenName
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listProfiles = /* GraphQL */ `
  query ListProfiles(
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userName
        familyName
        givenName
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTestExecution = /* GraphQL */ `
  query GetTestExecution($id: ID!) {
    getTestExecution(id: $id) {
      id
      score
      dateTimeStarted
      answers
      TestExecutionStatus
      dateTimeFinished
      durationMinutes
      studentId
      testID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listTestExecutions = /* GraphQL */ `
  query ListTestExecutions(
    $filter: ModelTestExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTestExecutions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        score
        dateTimeStarted
        answers
        TestExecutionStatus
        dateTimeFinished
        durationMinutes
        studentId
        testID
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const testExecutionsByTestID = /* GraphQL */ `
  query TestExecutionsByTestID(
    $testID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTestExecutionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    testExecutionsByTestID(
      testID: $testID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        score
        dateTimeStarted
        answers
        TestExecutionStatus
        dateTimeFinished
        durationMinutes
        studentId
        testID
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTest = /* GraphQL */ `
  query GetTest($id: ID!) {
    getTest(id: $id) {
      id
      Topic
      Grade
      Type
      name
      questions {
        id
        question
        image_name
        possible_answers {
          possibleAnswer
          isCorrect
          explanation
          __typename
        }
        correct_answer
        explanation
        reference
        questionType
        correct_answer_image
        __typename
      }
      durationInMinutes
      numberOfQuestions
      TestExecutions {
        items {
          id
          score
          dateTimeStarted
          answers
          TestExecutionStatus
          dateTimeFinished
          durationMinutes
          studentId
          testID
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTests = /* GraphQL */ `
  query ListTests(
    $filter: ModelTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        Topic
        Grade
        Type
        name
        questions {
          id
          question
          image_name
          possible_answers {
            possibleAnswer
            isCorrect
            explanation
            __typename
          }
          correct_answer
          explanation
          reference
          questionType
          correct_answer_image
          __typename
        }
        durationInMinutes
        numberOfQuestions
        TestExecutions {
          items {
            id
            score
            dateTimeStarted
            answers
            TestExecutionStatus
            dateTimeFinished
            durationMinutes
            studentId
            testID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
